import { useState } from 'react'
import { LabelDetail } from '../../types/label'
import { formatNumber } from '../../utils'
import styles from './Labels.module.css'

function stripDiscogsMarkup(text: string): string {
  return text
    .replace(/\[url=[^\]]+\]([^\[]*)\[\/url\]/g, '$1')
    .replace(/\[b\]([^\[]*)\[\/b\]/g, '$1')
    .replace(/\[i\]([^\[]*)\[\/i\]/g, '$1')
    .replace(/\[a=([^\]]+)\]/g, '$1')
    .replace(/\[l=([^\]]+)\]/g, '$1')
    .replace(/\[\/?[^\]]+\]/g, '')
    .trim()
}

interface LabelHeaderProps {
  label: LabelDetail
}

export function LabelHeader({ label }: LabelHeaderProps) {
  const [expanded, setExpanded] = useState(false)
  const profile = label.profile ? stripDiscogsMarkup(label.profile) : null

  return (
    <div className={styles.entityHeader}>
      <div className={styles.entityAvatar}>
        {label.cover_image ? (
          <img src={label.cover_image} alt={label.name} />
        ) : (
          <div className={styles.entityNoImage}>
            <i className="bi bi-tag-fill"></i>
          </div>
        )}
      </div>

      <div className={styles.entityInfo}>
        <div className={styles.entityName}>{label.name}</div>

        <div className={styles.entityStats}>
          <span>{formatNumber(label.release_count)} releases</span>
          {label.total_want > 0 && <span>{formatNumber(label.total_want)} wants</span>}
        </div>

        {profile && (
          <div className={styles.entityBio}>
            <p className={expanded ? styles.bioExpanded : styles.bioClamped}>
              {profile}
            </p>
            {profile.length > 200 && (
              <button className={styles.bioToggle} onClick={() => setExpanded(e => !e)}>
                {expanded ? 'Show less' : 'Show more'}
              </button>
            )}
          </div>
        )}

        {label.urls && label.urls.length > 0 && (
          <div className={styles.entityUrls}>
            {label.urls.slice(0, 5).map((url, i) => {
              try {
                return (
                  <a key={i} href={url} target="_blank" rel="noopener noreferrer" className={styles.entityUrl}>
                    {new URL(url).hostname.replace('www.', '')}
                  </a>
                )
              } catch {
                return null
              }
            })}
          </div>
        )}
      </div>
    </div>
  )
}
